module.exports = __webpack_public_path__ + "static/img/11.b1837f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/11.png
// module id = zeRB
// module chunks = 0